import React from "react";
import { colors } from "src/styles/variables";

import SVG from "../SVG";

export default SVG(() => (
  <svg viewBox="0 0 40 40" fill="none">
    <defs>
      <linearGradient id="instaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop
          offset="0%"
          stopColor={colors.instagram.color1}
          stopOpacity="100%"
        />
        <stop
          offset="25%"
          stopColor={colors.instagram.color2}
          stopOpacity="100%"
        />
        <stop
          offset="50%"
          stopColor={colors.instagram.color3}
          stopOpacity="100%"
        />
        <stop
          offset="75%"
          stopColor={colors.instagram.color4}
          stopOpacity="100%"
        />
        <stop
          offset="100%"
          stopColor={colors.instagram.color5}
          stopOpacity="100%"
        />
      </linearGradient>
    </defs>
    <path
      d="M20 11.127C22.8918 11.127 23.2312 11.1398 24.3742 11.1914C25.4312 11.2387 26.0027 11.4148 26.3851 11.5652C26.8922 11.7629 27.2531 11.9949 27.6312 12.3731C28.0093 12.7512 28.2457 13.1121 28.439 13.6191C28.5851 14.0016 28.7656 14.5731 28.8129 15.6301C28.8644 16.7731 28.8773 17.1125 28.8773 20.0043C28.8773 22.8961 28.8644 23.2356 28.8129 24.3785C28.7656 25.4356 28.5894 26.007 28.439 26.3895C28.2414 26.8965 28.0093 27.2574 27.6312 27.6356C27.2531 28.0137 26.8922 28.25 26.3851 28.4434C26.0027 28.5895 25.4312 28.7699 24.3742 28.8172C23.2312 28.8688 22.8918 28.8816 20 28.8816C17.1082 28.8816 16.7687 28.8688 15.6258 28.8172C14.5687 28.7699 13.9972 28.5938 13.6148 28.4434C13.1078 28.2457 12.7469 28.0137 12.3687 27.6356C11.9906 27.2574 11.7543 26.8965 11.5609 26.3895C11.4148 26.007 11.2344 25.4356 11.1871 24.3785C11.1355 23.2356 11.1226 22.8961 11.1226 20.0043C11.1226 17.1125 11.1355 16.7731 11.1871 15.6301C11.2344 14.5731 11.4105 14.0016 11.5609 13.6191C11.7586 13.1121 11.9906 12.7512 12.3687 12.3731C12.7469 11.9949 13.1078 11.7586 13.6148 11.5652C13.9972 11.4191 14.5687 11.2387 15.6258 11.1914C16.7687 11.1356 17.1082 11.127 20 11.127ZM20 9.17618C17.0609 9.17618 16.6914 9.18907 15.5355 9.24063C14.384 9.29219 13.5976 9.47696 12.9101 9.74337C12.1969 10.0184 11.5953 10.3922 10.9937 10.9938C10.3922 11.5953 10.0226 12.2012 9.74333 12.9102C9.47693 13.5977 9.29216 14.384 9.2406 15.5398C9.18904 16.6914 9.17615 17.0609 9.17615 20C9.17615 22.9391 9.18904 23.3086 9.2406 24.4645C9.29216 25.616 9.47693 26.4023 9.74333 27.0941C10.0183 27.8074 10.3922 28.409 10.9937 29.0106C11.5953 29.6121 12.2011 29.9816 12.9101 30.2609C13.5976 30.5273 14.384 30.7121 15.5398 30.7637C16.6957 30.8152 17.0609 30.8281 20.0043 30.8281C22.9476 30.8281 23.3129 30.8152 24.4687 30.7637C25.6203 30.7121 26.4066 30.5273 27.0984 30.2609C27.8117 29.9859 28.4133 29.6121 29.0148 29.0106C29.6164 28.409 29.9859 27.8031 30.2652 27.0941C30.5316 26.4066 30.7164 25.6203 30.7679 24.4645C30.8195 23.3086 30.8324 22.9434 30.8324 20C30.8324 17.0566 30.8195 16.6914 30.7679 15.5356C30.7164 14.384 30.5316 13.5977 30.2652 12.9059C29.9902 12.1926 29.6164 11.591 29.0148 10.9895C28.4133 10.3879 27.8074 10.0184 27.0984 9.73907C26.4109 9.47266 25.6246 9.2879 24.4687 9.23633C23.3086 9.18907 22.939 9.17618 20 9.17618Z"
      fill="url(#instaGradient)"
    />
    <path
      d="M20 14.4398C16.932 14.4398 14.4398 16.9277 14.4398 20C14.4398 23.0723 16.932 25.5602 20 25.5602C23.0679 25.5602 25.5601 23.068 25.5601 20C25.5601 16.932 23.0679 14.4398 20 14.4398ZM20 23.6094C18.0062 23.6094 16.3906 21.9938 16.3906 20C16.3906 18.0063 18.0062 16.3906 20 16.3906C21.9937 16.3906 23.6094 18.0063 23.6094 20C23.6094 21.9938 21.9937 23.6094 20 23.6094Z"
      fill="url(#instaGradient)"
    />
    <path
      d="M25.7793 15.5184C26.496 15.5184 27.0769 14.9374 27.0769 14.2207C27.0769 13.504 26.496 12.923 25.7793 12.923C25.0626 12.923 24.4816 13.504 24.4816 14.2207C24.4816 14.9374 25.0626 15.5184 25.7793 15.5184Z"
      fill="url(#instaGradient)"
    />
  </svg>
));
